import React from "react";
import styled from "styled-components";
import { Icon, Theme, colors } from "@literati/public-ui-shared-react";
import {
  BookShuffleDecisionType,
  SwipeStatus,
  swipeStatusIconNameMap,
} from "components/bookShuffle/bookShuffleTypes";

/** This is the className that will be pre-pended to all of BookShuffleDecisionIcon's inner component classNames */
export const BOOK_SHUFFLE_DECISION_ICON_CLASS_BASE =
  "book-shuffle-decision-icon";

/** These are all of the internal classNames that are used within the BookShuffleDecisionIcon component */
export const BookShuffleDecisionIconClassName = {
  BASE: BOOK_SHUFFLE_DECISION_ICON_CLASS_BASE,
} as const;

const StyledDiv = styled.div<{ $iconName: BookShuffleDecisionType }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 64px;
  height: 64px;

  ${({ $iconName }) =>
    $iconName === SwipeStatus.ACCEPTED &&
    `
    background: ${colors.periwinkleShade1};
    padding: 0 0 4px 2px;
  `}

  ${({ $iconName }) =>
    $iconName === SwipeStatus.REJECTED &&
    `
    background: ${colors.publisherOrange};
    padding: 2px 2px 0 0;
  `}
`;

const StyledIcon = styled(Icon)<{ $iconName: BookShuffleDecisionType }>`
  path {
    fill: ${colors.white};
  }
`;

export interface BookShuffleDecisionIconProps {
  className?: string;
  type: BookShuffleDecisionType;
}

export const BookShuffleDecisionIcon = ({
  className = "",
  type,
}: BookShuffleDecisionIconProps) => {
  return (
    <Theme>
      <StyledDiv
        className={`${BookShuffleDecisionIconClassName.BASE} ${className}`}
        $iconName={type}
      >
        <StyledIcon $iconName={type} name={swipeStatusIconNameMap[type]} />
      </StyledDiv>
    </Theme>
  );
};
